import { render, staticRenderFns } from "./pdf-preview.vue?vue&type=template&id=64377d07&scoped=true"
import script from "./pdf-preview.vue?vue&type=script&lang=js"
export * from "./pdf-preview.vue?vue&type=script&lang=js"
import style0 from "./pdf-preview.vue?vue&type=style&index=0&id=64377d07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64377d07",
  null
  
)

export default component.exports